import { useState, useEffect } from "react";
import { useAppSelector } from "../../hooks/useReduxMethods";
import {
  getUserPrefersLang,
  saveUserPrefersLang,
} from "../../shared/helpersMethod";
import { useTranslation } from "react-i18next";

const DynamicComponent = ({ pageId }) => {
  const { i18n, t } = useTranslation();
  const [Component, setComponent] = useState(null);
  const { bussinessData } = useAppSelector((state: any) => state.bussinessData);
  const currentLang = getUserPrefersLang();
  //   const componentMap = {
  //     101: Custom101,
  //   };
  useEffect(() => {
    console.log(pageId);
    if (bussinessData && Object.keys(bussinessData).length !== 0) {
      if (currentLang === null) {
        i18n.changeLanguage(bussinessData.defaultLang);
        saveUserPrefersLang(bussinessData.defaultLang);
        getUserPrefersLang();
        if (bussinessData.defaultLang === "ar") {
          document.getElementsByTagName("html")[0].setAttribute("lang", "ar");
          document.getElementsByTagName("body")[0].setAttribute("dir", "rtl");
        }
        return;
      }
      if (currentLang !== null) {
        i18n.changeLanguage(currentLang);
      }
    }
    // console.log(bussinessData);
  }, [bussinessData]);
  useEffect(() => {
    console.log(pageId);
    import(`./Custom${pageId}`)
      .then((mod) => setComponent(() => mod.default))
      .catch(() => setComponent(null));
  }, [pageId]);
  console.log(
    " in DynamicComponent.....Parameter: " +
      pageId +
      ", Component: Custom" +
      pageId
  );
  return Component ? (
    <Component pageId={pageId} />
  ) : (
    <div>
      Loading or component not found...I am going to redirect to 404 page
    </div>
  );
};
export default DynamicComponent;
